const UniqueDigitId = () => String(new Date().valueOf());

export default UniqueDigitId;
